/** The Dataobjects page's table: every dataobject, what it holds and what uses it. */

export default {
	dataobjectOverview: {
		create: "New dataobject",
		search: "Search label or code name…",
		noResults: "No dataobjects match.",
		filter: {
			view: "View",
			noView: "In no view",
			usage: "Used in",
			unused: "Not used",
			related: "Related to",
		},
		attentionCount: "Needs attention ({n})",
		resizeColumn: "Resize {column}",
		rows: {
			label: "Rows",
			dataobjects: "Dataobjects",
			attributes: "Attributes",
		},
		searchAttributes: "Search attributes and relations…",
		attributeColumns: {
			attribute: "Attribute",
			type: "Type",
			required: "Required",
			axiom: "Axiom",
			target: "Target",
		},
		attributeCells: {
			relation: "Relation",
			required: "Required",
			optional: "Optional",
			list: "{type}[]",
			axiomReads: "from {fields}",
			// A group band's count, attributes and relations apart; "… of …" while the search or
			// "Needs attention" narrows the rows. Plural by the total.
			count: {
				attributes: "{n} attribute | {n} attributes",
				attributesNarrowed: "{n} of {total} attribute | {n} of {total} attributes",
				relations: "{n} relation | {n} relations",
				relationsNarrowed: "{n} of {total} relation | {n} of {total} relations",
			},
		},
		columns: {
			dataobject: "Dataobject",
			attributes: "Attributes",
			relations: "Relates to",
			views: "On views",
			usedIn: "Used in",
			terminology: "Terminology",
		},
		cells: {
			axioms: "{n} axiom | {n} axioms",
			noRelations: "None",
			relatedFrom: "← from",
			relatesToHeading: "{name} relates to",
			allRelatesTo: "All {n} dataobjects {name} relates to",
			relatedFromHeading: "Related to {name}",
			allRelatedFrom: "All {n} dataobjects that relate to {name}",
			noView: "In no view",
			notUsed: "Not used yet",
			manualName: "Code name pinned by hand",
			predefined: "Notitia",
			fromAlias: "From {alias}",
			unverified: "{n} unverified",
			coverage: "{filled} / {total}",
			missingNamed: "{langs} missing",
			missingCount: "{n} missing",
			allProcesses: "All {n} processes using {name}",
			viewsShowing: "Views showing {name}",
			allViews: "All {n} views showing {name}",
			processesUsing: "Processes using {name}",
			activitiesOf: "Activities of {name}",
			allActivities: "All {n} activities of {name}",
		},
		menu: {
			more: "More actions for {name}",
			openInView: "Open in view",
			addToView: "Add to view",
		},
		places: {
			createAndOpen: "Create and open",
			newView: "New view…",
		},
		usage: {
			tab: "Used in",
			terminology: "Terminology",
			noLabel: "No label",
			unverified: "Unverified",
			views: "Views",
			processes: "Processes",
			activities: "Activities",
			none: "None",
			addToView: "Add to view",
			newActivity: "New activity",
		},
		createDialog: {
			label: "Label",
			codeName: "Code name {name}",
			color: "Colour",
			view: "Add to a view",
			optional: "Optional",
			noView: "No view — it stays in this table",
		},
		deleteDialog: {
			title: "Delete {name}?",
			intro: "Deleting {name} also removes everything listed below. This cannot be undone.",
			introAlone: "Nothing else refers to {name}. This cannot be undone.",
			relations: "Relations that point to it — removed",
			activities: "Its activities — deleted with it",
			views: "Views — taken off",
			leftBehind: "Its terminology entry stays",
			leftBehindNote:
				"The label and its translations are not deleted. They stay in the terminology list, attached to nothing.",
			confirm: "Delete {name}",
			blockedTitle: "{name} can’t be deleted",
			blockedIntro:
				"Other parts of the model are built on {name}. Change these first, then delete it.",
			processes: "Processes that use it",
			embeds: "Attributes whose type is {name}",
			axioms: "Axioms that read it",
			actions: "Actions that use it",
			actionMakes: "makes it",
			actionActsOn: "acts on it",
			actionRelation: "uses {relation}",
		},
	},
};
